export const TOOTH_STATUSES = [
    'present',
    'missing',
    'implant',
    'crown',
    'filling',
    'root-canal',
    'bridge',
    'veneer',
    'extraction-planned',
    'attention',
];
//# sourceMappingURL=types.js.map